// Defensive: `vacancies` is set inline in footer.php only when there are
// vacancy posts. Using typeof avoids a ReferenceError on pages without it,
// which would otherwise kill the rest of the bundle (accordion, modals, etc.).
if (typeof vacancies !== 'undefined' && vacancies) {
    const vacanciesMenuLink = document.querySelector('.vacancies-menu-link');

    if (vacanciesMenuLink) {
        const link = vacanciesMenuLink.querySelector('a');
        const span = document.createElement('span');
        span.classList.add('background-color-primary');
        span.textContent = vacancies;
        link.appendChild(span);
    }
}
